export default __webpack_public_path__ + "static/media/no-img.c666db58.png";